export const queryParamBuilder = (url: string, query?: {
  [key: string]: string | number | boolean ;
}) => {
  let newUrl = url;

  if (query && Object.keys(query).length > 0) {
    const searchParams = new URLSearchParams();
    Object.entries(query).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        searchParams.append(key, String(value));
      }
    });

    const queryString = searchParams.toString();
    if (queryString) {
      newUrl = `${url}?${queryString}`;
    }
  }

  return newUrl;
};
